(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["enea-bureau-base"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('enea-bureau-component')) {
  customElements.define('enea-bureau-component', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.abortController) return;
        this.abortController = new AbortController();
        this.options = { signal: this.abortController.signal };
        this.setupAccordions();
        this.setupChecklist();
        this.setupProducts();
        document.addEventListener('shopify:block:select', event => {
          if (String(event.detail?.sectionId) !== this.dataset.sectionId && !this.contains(event.target)) return;
          const id = String(event.detail?.blockId || '');
          const block = [...this.querySelectorAll('[data-edb-block]')].find(node => node.dataset.edbBlock === id);
          if (!block) return;
          if (block.matches('details')) block.open = true;
          if (block.dataset.panel) this.activateTab(block.dataset.panel);
        }, this.options);
        this.dataset.enhanced = 'true';
      });
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
      delete this.dataset.enhanced;
    }
    setupAccordions() {
      this.querySelectorAll('[data-single="true"]').forEach(group => {
        const details = [...group.querySelectorAll('details')];
        details.forEach(item => item.addEventListener('toggle', () => {
          if (item.open) details.forEach(other => { if (other !== item) other.open = false; });
        }, this.options));
      });
    }
    setupChecklist() {
      const list = this.querySelector('[data-checklist]');
      if (!list) return;
      const inputs = [...list.querySelectorAll('.edb-check-input')];
      const total = inputs.length;
      const key = ['enea-bureau', location.pathname, this.dataset.sectionId, list.dataset.version].join(':');
      const remember = list.dataset.remember === 'true' && !window.Shopify?.designMode;
      if (remember) {
        try {
          const saved = JSON.parse(localStorage.getItem(key) || '[]');
          if (Array.isArray(saved)) inputs.forEach(input => { input.checked = saved.includes(input.value); });
        } catch {}
      }
      const update = persist => {
        const checked = inputs.filter(input => input.checked);
        const count = checked.length;
        const score = list.querySelector('[data-count]');
        const fill = list.querySelector('[data-fill]');
        const progress = list.querySelector('[role="progressbar"]');
        const feedback = list.querySelector('[data-feedback]');
        if (score) score.textContent = String(count);
        if (fill) fill.style.width = (total ? count / total * 100 : 0) + '%';
        if (progress) progress.setAttribute('aria-valuenow', String(count));
        if (feedback) {
          const message = count === 0 ? list.dataset.empty : count === total ? list.dataset.complete : list.dataset.progress;
          feedback.textContent = (message || '').replaceAll('{count}', String(count)).replaceAll('{total}', String(total));
        }
        if (persist && remember) {
          try { localStorage.setItem(key, JSON.stringify(checked.map(input => input.value))); } catch {}
        }
      };
      inputs.forEach(input => input.addEventListener('change', () => update(true), this.options));
      list.querySelector('[data-reset]')?.addEventListener('click', () => {
        inputs.forEach(input => { input.checked = false; });
        update(true);
      }, this.options);
      update(false);
    }
    setupProducts() {
      this.tabs = [...this.querySelectorAll('[data-tab]')];
      if (!this.tabs.length) return;
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activateTab(tab.dataset.tab), this.options);
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.activateTab(this.tabs[next].dataset.tab);
          this.tabs[next].focus();
        }, this.options);
      });
      const active = this.tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
      this.activateTab(active.dataset.tab);
    }
    activateTab(id) {
      if (!this.tabs?.some(tab => tab.dataset.tab === id)) return;
      this.tabs.forEach(tab => {
        const active = tab.dataset.tab === id;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach(panel => { panel.hidden = panel.dataset.panel !== id; });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["enea02-base"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('enea-02-component')) {
  customElements.define('enea-02-component', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected) return;
        this.abortController?.abort();
        this.abortController = new AbortController();
        this.options = { signal: this.abortController.signal };
        this.setupAccordions();
        this.setupChecklist();
        this.setupProducts();
        document.addEventListener('shopify:block:select', event => {
          if (String(event.detail?.sectionId) !== this.dataset.sectionId && !this.contains(event.target)) return;
          const id = String(event.detail?.blockId || '');
          const block = [...this.querySelectorAll('[data-edb-block]')].find(node => node.dataset.edbBlock === id);
          if (!block) return;
          if (block.matches('details')) block.open = true;
          if (block.dataset.panel) this.activateTab(block.dataset.panel);
        }, this.options);
        this.dataset.enhanced = 'true';
        if (!this.contentObserver) {
          this.contentObserver = new MutationObserver(records => {
            const selector = '[data-panel], [data-checklist], .edb-check-input, details';
            const changed = records.some(record => [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))));
            if (changed) this.connectedCallback();
          });
          this.contentObserver.observe(this, {childList:true, subtree:true});
        }
      });
    }
    disconnectedCallback() {
      this.contentObserver?.disconnect();
      this.contentObserver = null;
      this.abortController?.abort();
      this.abortController = null;
      delete this.dataset.enhanced;
    }
    setupAccordions() {
      this.querySelectorAll('[data-single="true"]').forEach(group => {
        const details = [...group.querySelectorAll('details')];
        details.forEach(item => item.addEventListener('toggle', () => {
          if (item.open) details.forEach(other => { if (other !== item) other.open = false; });
        }, this.options));
      });
    }
    setupChecklist() {
      const list = this.querySelector('[data-checklist]');
      if (!list) return;
      const inputs = [...list.querySelectorAll('.edb-check-input')];
      const total = inputs.length;
      const totalLabel = list.querySelector('.edb-score-total');
      if (totalLabel) totalLabel.textContent = '/ ' + total;
      list.querySelector('[role="progressbar"]')?.setAttribute('aria-valuemax', String(total));
      const key = ['enea-bureau', location.pathname, this.dataset.sectionId, this.dataset.blockId, list.dataset.version].join(':');
      const remember = list.dataset.remember === 'true' && !window.Shopify?.designMode;
      if (remember) {
        try {
          const saved = JSON.parse(localStorage.getItem(key) || '[]');
          if (Array.isArray(saved)) inputs.forEach(input => { input.checked = saved.includes(input.value); });
        } catch {}
      }
      const update = persist => {
        const checked = inputs.filter(input => input.checked);
        const count = checked.length;
        const score = list.querySelector('[data-count]');
        const fill = list.querySelector('[data-fill]');
        const progress = list.querySelector('[role="progressbar"]');
        const feedback = list.querySelector('[data-feedback]');
        if (score) score.textContent = String(count);
        if (fill) fill.style.width = (total ? count / total * 100 : 0) + '%';
        if (progress) progress.setAttribute('aria-valuenow', String(count));
        if (feedback) {
          const message = count === 0 ? list.dataset.empty : count === total ? list.dataset.complete : list.dataset.progress;
          feedback.textContent = (message || '').replaceAll('{count}', String(count)).replaceAll('{total}', String(total));
        }
        if (persist && remember) {
          try { localStorage.setItem(key, JSON.stringify(checked.map(input => input.value))); } catch {}
        }
      };
      inputs.forEach(input => input.addEventListener('change', () => update(true), this.options));
      list.querySelector('[data-reset]')?.addEventListener('click', () => {
        inputs.forEach(input => { input.checked = false; });
        update(true);
      }, this.options);
      update(false);
    }
    setupProducts() {
      this.panels = [...this.querySelectorAll('[data-panel]')];
      const tablist = this.querySelector('[data-tablist]');
      if (!tablist || !this.panels.length) return;
      tablist.replaceChildren();
      tablist.setAttribute('role', 'tablist');
      this.panels.forEach((panel, index) => {
        const tab = document.createElement('button');
        tab.type = 'button';
        tab.id = 'Tab-' + this.dataset.sectionId + '-' + panel.dataset.panel;
        tab.dataset.tab = panel.dataset.panel;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panel.id);
        tab.setAttribute('aria-selected', String(index === 0));
        tab.tabIndex = index === 0 ? 0 : -1;
        tab.append(document.createTextNode(panel.dataset.tabTitle || ''));
        const number = document.createElement('span');
        number.setAttribute('aria-hidden', 'true');
        number.textContent = String(index + 1).padStart(2, '0');
        tab.append(number);
        tablist.append(tab);
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        panel.tabIndex = 0;
      });
      this.tabs = [...tablist.querySelectorAll('[data-tab]')];
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activateTab(tab.dataset.tab), this.options);
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.activateTab(this.tabs[next].dataset.tab);
          this.tabs[next].focus();
        }, this.options);
      });
      const active = this.tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
      this.activateTab(active.dataset.tab);
    }
    activateTab(id) {
      if (!this.tabs?.some(tab => tab.dataset.tab === id)) return;
      this.tabs.forEach(tab => {
        const active = tab.dataset.tab === id;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach(panel => { panel.hidden = panel.dataset.panel !== id; });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
